import { defineStore } from 'pinia';
import { IToastAlert, IToastAlertInput } from '@/interfaces/components/toast-alert.interface';
import { ToastAlertType } from '@/enums/toast-alert-enum';
import { ref } from 'vue';

const DEFAULT_DURATION = 8000; // Default timeout before the toast would dissappear (8s)

export const ToastAlertMeta: Record<
  ToastAlertType,
  { icon: string; closeIcon: string; textColour: string; backgroundColour: string }
> = {
  [ToastAlertType.SUCCESS]: {
    icon: require('@/assets/icons/alert-success-white.svg'),
    closeIcon: require('@/assets/icons/white-close-icon.svg'),
    textColour: 'text-racq-true-white',
    backgroundColour: 'bg-racq-alerts-success-dark',
  },
  [ToastAlertType.ERROR]: {
    icon: require('@/assets/icons/alert-error-white.svg'),
    closeIcon: require('@/assets/icons/white-close-icon.svg'),
    textColour: 'text-racq-true-white',
    backgroundColour: 'bg-racq-alerts-error-danger',
  },
  [ToastAlertType.INFO]: {
    icon: require('@/assets/icons/alert-information-white.svg'),
    closeIcon: require('@/assets/icons/white-close-icon.svg'),
    textColour: 'text-racq-true-white',
    backgroundColour: 'bg-racq-alerts-information-dark',
  },
  [ToastAlertType.WARNING]: {
    icon: require('@/assets/icons/alert-warning-grey.svg'),
    closeIcon: require('@/assets/icons/grey-close-icon.svg'),
    textColour: 'text-racq-dark-grey',
    backgroundColour: 'bg-racq-alerts-warning-medium',
  },
};

let idCounter = 0;

export const useToastAlertStore = defineStore('ToastAlert', () => {
  const toastAlerts = ref<IToastAlert[]>([]);

  const addToastAlert = (toastAlertInput: IToastAlertInput) => {
    const id = ++idCounter;
    const duration = toastAlertInput.duration ?? DEFAULT_DURATION;
    const toastAlert: IToastAlert = {
      id,
      type: toastAlertInput.type,
      title: toastAlertInput.title,
      description: toastAlertInput.description,
      duration: toastAlertInput.duration,
    };
    toastAlerts.value.unshift(toastAlert);

    // schedule auto-close if duration > 0
    if (duration && duration > 0) {
      setTimeout(() => initiateCloseToastAlert(id), duration);
    }
  };

  const initiateCloseToastAlert = (id: number) => {
    const idx = toastAlerts.value.findIndex((t) => t.id === id);
    if (idx !== -1) {
      toastAlerts.value.splice(idx, 1);
    }
  };

  return {
    toastAlerts,
    addToastAlert,
    initiateCloseToastAlert,
  };
});
